import React from 'react';
import classNames from 'classnames';

interface IHeaderTitleProps {
  dynamicStyle: any;
  styles: any;
  children: string;
}

function HeaderTitle({ dynamicStyle, styles, children }: IHeaderTitleProps) {
  return (
    <h1
      data-hook="main.header.title"
      className={classNames(styles.headerTitle, dynamicStyle.headerTitle)}
    >
      {children}
    </h1>
  );
}

export default HeaderTitle;
